export default {"src":"/_next/static/media/loader2.d09e5af1.gif","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};